import type { GetProject } from '@/server/api/rest/project/project-repository.ssr';
import { fetchProject } from '@/shared/api';
import { useQuery } from '@tanstack/react-query';

export const useProject = (slug: string) => {
  return useQuery<GetProject>({
    queryKey: ['project', slug],
    queryFn: () => fetchProject(slug),
  });
};
